export const t_global_breakpoint_lg = {
  "name": "--pf-t--global--breakpoint--lg",
  "value": "62rem",
  "var": "var(--pf-t--global--breakpoint--lg)"
};
export default t_global_breakpoint_lg;